import { NavLink } from 'react-router-dom';
import { formatScaledCount } from '../lib/scaling';
import { useBlobStore } from '../state/blobStore';
import { useSelectionStore } from '../state/selectionStore';
import { useUiStore } from '../state/uiStore';

function formatBuildLabel(generatedAt: string): string {
  const d = new Date(generatedAt);
  if (Number.isNaN(d.getTime())) return generatedAt;
  return d.toISOString().slice(0, 10);
}

function BuildBadge() {
  const blob = useBlobStore((s) => s.blob);
  const loading = useBlobStore((s) => s.loading);
  const error = useBlobStore((s) => s.error);

  if (error) {
    return (
      <div className="top-bar__build top-bar__build--error" title={error.message}>
        build · failed
      </div>
    );
  }
  if (loading || !blob) {
    return (
      <div className="top-bar__build top-bar__build--loading">
        <span className="top-bar__build-skeleton" aria-hidden="true" />
        <span className="visually-hidden">Loading population metadata</span>
      </div>
    );
  }
  return (
    <div className="top-bar__build">
      build {formatBuildLabel(blob.meta.generatedAt)} · v{blob.meta.schemaVersion} ·{' '}
      {formatScaledCount(blob.meta.personCount, blob.meta.personCount)} people
    </div>
  );
}

function FilterToggle() {
  const open = useUiStore((s) => s.filterPanelOpen);
  const toggle = useUiStore((s) => s.toggleFilterPanel);
  return (
    <button
      type="button"
      className={`top-bar__filter${open ? ' top-bar__filter--on' : ''}`}
      aria-pressed={open}
      onClick={toggle}
    >
      Filter
    </button>
  );
}

function ClearSelectionButton() {
  const mode = useSelectionStore((s) => s.mode);
  const clearSelection = useSelectionStore((s) => s.clearSelection);
  if (mode === 'idle') return null;
  return (
    <button
      type="button"
      className="top-bar__clear"
      onClick={clearSelection}
      aria-label={
        mode === 'drawing'
          ? 'Cancel drawing selection'
          : 'Clear map selection'
      }
    >
      {mode === 'drawing' ? 'Cancel draw' : 'Clear selection'}
    </button>
  );
}

export default function TopBar() {
  return (
    <header className="top-bar" role="banner">
      <NavLink to="/" className="top-bar__brand" end>
        UK Populace Digital Twin
      </NavLink>
      <nav className="top-bar__nav" aria-label="Primary">
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            `top-bar__nav-link${isActive ? ' top-bar__nav-link--active' : ''}`
          }
        >
          Map
        </NavLink>
        <NavLink
          to="/dashboards"
          className={({ isActive }) =>
            `top-bar__nav-link${isActive ? ' top-bar__nav-link--active' : ''}`
          }
        >
          Dashboards
        </NavLink>
      </nav>
      <div className="top-bar__filters" aria-hidden="true" />
      <ClearSelectionButton />
      <FilterToggle />
      <BuildBadge />
    </header>
  );
}
